import { Injectable } from '@angular/core';
import { StoreModel, StoreContent } from '../model/store-model';
import { MergeData } from '../model/merge-data';
import { Observable, of } from 'rxjs';
import { startWith, filter } from 'rxjs/operators';

@Injectable()
export class StoreService {

  private storage: StoreModel = {};

  constructor() { }

  addStorageType(dataType: any, storeContent: StoreContent<any>): void {
    if (!this.storage[dataType]) {
      this.storage[dataType] = storeContent;
    }
  }

  isStorageTypeExists(dataType: any): boolean {
    return this.storage.hasOwnProperty(dataType);
  }

  getAll<T>(dataType: any): Observable<T[] | null> {
    const storeContent = this.storage[dataType];
    if (storeContent)
      return this.storage[dataType].getAll();
    else {
      console.error(`There's no ${dataType} in storage to get all data`);
      return of(null);
    }
  }

  getByKey<T>(dataType: any, key: string): Observable<T | null> {
    const storeContent = this.storage[dataType];
    if (storeContent)
      return this.storage[dataType].getByKey(key);
    else {
      console.error(`There's no ${dataType} in storage to get by key`);
      return of(null);
    }
  }

  getByKeyObject<T>(dataType: any, keyObject: any): Observable<T | null> {
    const storeContent = this.storage[dataType];
    if (storeContent)
      return this.storage[dataType].getByKeyObject(keyObject);
    else {
      console.error(`There's no ${dataType} in storage to get by key object`);
      return of(null);
    }
  }

  getByValue<T>(dataType: any, field: string, value: any): Observable<T[] | null> {
    const storeContent = this.storage[dataType];
    if (storeContent)
      return this.storage[dataType].getByValue(field, value);
    else {
      console.error(`There's no ${dataType} in storage to get by value`);
      return of(null);
    }
  }

  connectToAllDataUpdates<T>(dataType: any): Observable<T[]> {
    const storeContent = this.storage[dataType];
    if (storeContent) {
      return storeContent.subscribeAllDataUpdates()
        .pipe(startWith(storeContent.getAllNow()), filter(data => data != null));
    } else
      console.error(`There's no ${dataType} in storage to connectToAllDataUpdates`);
  }

  connectToIncrementalUpdates<T>(dataType: any): Observable<T[]> {
    const storeContent = this.storage[dataType];
    if (storeContent) {
      return storeContent.subscribeIncrementalUpdates()
        .pipe(startWith(storeContent.getAllNow()), filter(data => data != null));
    } else
      console.error(`There's no ${dataType} in storage to connectToIncrementalUpdates`);
  }

  store<T>(dataType: any, data: T[]): void {
    const storeContent = this.storage[dataType];
    if (storeContent)
      storeContent.store(data);
    else
      console.error(`There's no ${dataType} in storage to store data`);
  }

  merge(dataType: any, data: MergeData[], createIfBaseNotExists: boolean = false): void {
    const storeContent = this.storage[dataType];
    if (storeContent)
      storeContent.merge(data, createIfBaseNotExists);
    else
      console.error(`There's no ${dataType} in storage to merge data`);
  }

  delete<T>(dataType: any, object: T): void {
    const storeContent = this.storage[dataType];
    if (storeContent)
      this.storage[dataType].delete(object);
    else
      console.error(`There's no ${dataType} in storage to delete element`);
  }

  clear(dataType: any): void {
    const storeContent = this.storage[dataType];
    if (storeContent)
      this.storage[dataType].clear();
    else
      console.error(`There's no ${dataType} in storage to clear`);
  }

  removeStorage(dataType: any): void {
    delete this.storage[dataType];
  }
}
